import { createAppKit } from "@reown/appkit/react";
import { bsc } from "@reown/appkit/networks";
import { http, WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";

const metadata = {
    name: "Airdiamond Presale",
    description: "Airdiamond Presale",
    url: "https://airdiamond.net", // origin must match your domain & subdomain
    icons: ["https://airdiamond.net/favicon.png"],
};
const queryClient = new QueryClient();

const projectId = "52b2ddc11a39d83a800cd7ced6f561b6";
const wagmiAdapter = new WagmiAdapter({
    networks: [bsc],
    projectId,
    ssr: false,
});

createAppKit({
    adapters: [wagmiAdapter],
    projectId,
    networks: [bsc],
    metadata,
    featuredWalletIds: [
        "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96", // MetaMask Wallet ID
        "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0", // Trust Wallet ID
    ],
    allWallets: "SHOW",
    features: {
        email: false, // E-posta girişi devre dışı bırakıldı
        socials: [],
    },
});
export const config = wagmiAdapter.wagmiConfig;

const ModalConnection = ({ children }) => {
    return (
        <WagmiProvider config={wagmiAdapter.wagmiConfig}>
            <QueryClientProvider client={queryClient}>
                {children}
            </QueryClientProvider>
        </WagmiProvider>
    );
};

export default ModalConnection;
